<template>
  <v-dialog :value="true" @input="close" :width="700">
    <v-card>
      <v-card-title class="title font-weight-regular justify-space-between">
        <span>New Campaign</span>
        <v-avatar
          color="primary lighten-2"
          class="subheading white--text"
          size="24"
          v-text="step"
        ></v-avatar>
      </v-card-title>
      <keep-alive>
        <v-window :value="step">
          <v-window-item :value="1">
            <v-card-text>
              <spinner v-if="loading" />
              <campaign-main-info
                ref="1"
                v-show="!loading"
                @submit="saveCampaign"
              />
            </v-card-text>
          </v-window-item>
          <v-window-item :value="2">
            <v-card-text>
              <spinner v-if="loading" />
              <lead-question 
                ref="2"
                v-show="!loading"
                @submit="saveQuestions"
                :withCampaignName="false"
              />
            </v-card-text>
          </v-window-item>
        </v-window>
      </keep-alive>
      <v-divider />
      <v-card-actions>
        <v-btn
          :disabled="step === 1"
          flat
          @click="step--"
        >
          Back
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="loading"
          color="primary"
          depressed
          @click="submitStep"
        >
          {{btnTitle}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import apiCall from '@/helpers/stepperApiCall';
import Spinner from '@/components/Spinner';
import LeadQuestion from '@/components/LeadQuestion';
import CampaignMainInfo from '@/components/CampaignMainInfo';
import CREATE_CAMPAIGN from '@/graphql/CreateCampaign.gql';
import { mapActions } from 'vuex';

export default {
  components: {
    Spinner,
    LeadQuestion,
    CampaignMainInfo,
  },
  data() {
    return {
      step: 1,
      isShown: true,
      loading: false,
      campaignData: {},
    };
  },
  computed: {
    btnTitle() {
      return this.step === 2 ? 'Create' : 'Next';
    },
  },
  methods: {
    ...mapActions(['trackEvent']),
    submitStep() {
      this.$refs[this.step].submit();
    },
    goBack() {
      this.step = this.step - 1;
    },
    close() {
      this.$router.go(-1);
    },
    saveCampaign(campaignData) {
      Object.assign(this.campaignData, campaignData);
      this.step = 2;
    },
    // eslint-disable-next-line
    saveQuestions: apiCall(async function({ inputPrompt, questions }) {
      const result = await this.$apollo.mutate({
        mutation: CREATE_CAMPAIGN,
        variables: {
          input: { ...this.campaignData, inputPrompt, questions },
        }
      });
      this.trackEvent({
        name: "Campaign Created",
        options: {
          "campaign_name": this.campaignData.campaignName,
          "campaign_uid": result.data.createCampaign.campaignId
        }
      });
      this.$router.push({ name: 'CampaignDetails', params: { id: result.data.createCampaign.campaignId } });
    }),
  },
};
</script>
<style scoped>
  .v-card__title--primary {
     padding-top: 16px;
  }
  hr {
    margin-top: 0;
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/modals/EditClientCampaignModal.vue